import { MutationTree } from 'vuex'

import { AppState, DataToPreloadStrategy, PreloadConsentStatus } from '@/@next/store/app'
import * as APP from '@/@next/store/app/types'

import { NetworkStatus } from '@/@next/@types'

export const mutations: MutationTree<AppState> =  {

  [APP.APP_IS_READY] (state, value: boolean) {
    state.isReady = value
  },

  [APP.SET_NETWORK] (state, network: NetworkStatus) {
    state.network = network
  },

  [APP.ADD_MODAL] (state, modal: any) {
    state.modals.push(modal)
  },

  [APP.REMOVE_CURRENT_MODAL] (state) {
    state.modals.splice(0, 1)
  },

  [APP.REMOVE_MODAL] (state, modal: any) {
    const index = state.modals.findIndex((m: any) => m === modal)
    if (index !== -1) {
      state.modals.splice(index, 1)
    }
  },

  [APP.SERVICE_WORKER_IS_READY] (state, value: boolean) {
    console.log('[Info][App] Service Worker is ready !');
    state.serviceWorkerIsReady = value
  },

  // Preloader Mutations
  [APP.PRELOAD_IS_READY]: (state, isReady: boolean) => {
    state.preloadIsReady = isReady
  },

  [APP.PRELOAD_CONFIGURATION] (state, configuration: any) {
    state.preloadConfiguration = configuration
  },

  [APP.DATA_TO_PRELOAD] (state, data: any) {
    state.dataToPreload = data
  },

  [APP.PRELOAD_RESSOURCE_STATUS] (state, status: string) {
    state.preloadRessources.status = status
  },

  [APP.PRELOAD_RESSOURCES] (state, data: any) {
    state.preloadRessources = { ...state.preloadRessources, ...data}
  },

  [APP.PRELOAD_FILE_STATUS] (state, status: string) {
    state.preloadFiles.status = status
  },

  [APP.PRELOAD_FILES] (state, data: any) {
    state.preloadFiles = { ...state.preloadFiles, ...data}
  },

  [APP.SHOW_PRELOAD_MODAL] (state, show: boolean) {
    state.showPreloadModal = show
  },

  [APP.CONSENT_PRELOAD] (state, consent: PreloadConsentStatus) {
    state.concentPreload = consent
  },

  [APP.PRELOAD_SUCCESS] (state, success: boolean) {
    state.preloadSuccess = success
    if (success) state.preloadError = false
  },

  [APP.PRELOAD_ERROR] (state, error: boolean) {
    state.preloadError = error
    if (error) state.preloadSuccess = false
  },

  [APP.NEED_TO_RELOAD_APP] (state, needToReloadApp: boolean) {
    state.needToReloadApp = needToReloadApp
  },

  [APP.DATA_TO_PRELOAD_STRATEGY] (state, preloadStrategy: DataToPreloadStrategy) {
    state.preloadStrategy = preloadStrategy
  },

  [APP.SHOW_PRELOAD_TOP_BAR_BUTTON] (state, show: boolean) {
    state.showPreloadTopBarButton = show
  }

}
